import { useEffect, useState } from "react";

import usePlayer from "./usePlayer";

export default function useIsAutoPlayed() {
  const [isAutoPlayed, setIsAutoPlayed] = useState();
  const player = usePlayer();

  useEffect(() => {
    if (player.isReady) {
      const urlParams = new URLSearchParams(window.location.search);
      const autoPlayed = urlParams.get("autoPlayed");
      setIsAutoPlayed(!!autoPlayed && !!player.getAutostart());
    }
  }, [player]);

  return isAutoPlayed;
}
